<script>
/** eslint-disable */
import Vue from 'vue';
import { tryRegisterStoreDynamically } from './store/loadPlanningList.store.js';

let namespace = Vue.observable({ id: undefined });

export default {
	name: 'StoreModuleInjector',
	provide: { namespace },
	watch: {
		$route: {
			immediate: true,
			handler(to) {
				namespace.id = to.params.searchId || -1;
				tryRegisterStoreDynamically(namespace.id);
			}
		}
	},
	created() {
		let id = this.$route.params.searchId || -1;
		namespace.id = id;
		namespace.tripId = this.$route.params.tripId;
		tryRegisterStoreDynamically(namespace.id);
	},
	render() {
		return this.$scopedSlots.default ? this.$scopedSlots.default({}) : null;
	},
};
</script>
